import React, { useEffect, useState } from 'react';
import { FlatList, View, ScrollView, TextInput } from "react-native";
import { Icon } from 'react-native-elements';
import { connect } from "react-redux";
import Colors from '../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { social_getTags, social_savePlayerTag } from '../../store/actionsv1/social';
import { PlayerTagProps, TagProps } from '../../store/types/soc_svc';
import TagCard from './components/TagCard';


const TagsScreen = ({ player, tags, player_tags, social_getTags, social_savePlayerTag }) => {
    const [ loading, setLoading ] = useState(false)
    const [ searchValue, setSearchValue ] = useState('')
    useEffect(() => {
        getTagsFromServer(0, 'selected')
    },[])

    const getTagsFromServer = async(offset:number, tag_type:string) => {
        setLoading(true)
        await social_getTags(offset, tag_type)
        setLoading(false)
    }

    const handleSavePlayerTag = async(tag:TagProps) => {
        const existing_player_tag = player_tags.find(pt => pt.tag_id == tag.tag_id)
        if(existing_player_tag){
            return await social_savePlayerTag({ ...existing_player_tag, status: existing_player_tag.status === 'following' ? 'not_following' : 'following' })
        }
        let newPT:PlayerTagProps = {
            player_tag_id: '',
            player_id: player.player_id,
            tag_id:tag.tag_id,
            tag:tag.tag,
            status: 'following',
            tag_type: 'selected',
            create_datetime:'', last_update_datetime:''
        }
        await social_savePlayerTag(newPT)
    }

    const renderTags = (data: {item:TagProps, index:number}) => {
        const player_tag = player_tags.find(pt => pt.tag_id == data.item.tag_id)
        return (
            <TagCard onFollow={(tag) => handleSavePlayerTag(tag)} viewer_id={player.player_id} tag={data.item} player_tag={player_tag}/>
        )
    }
    
    return (
        <View style={{ flex:1 }}>
            <ScrollView style={{ flex:1 }}>
                <View style={{ flexDirection:'row', padding:10 }}>
                    <View style={{ flex:1, flexDirection:'row', borderRadius:20 }}>
                        <Icon type='feather' name='search' color={Colors.brand.slate} />
                        <TextInput style={{ flex:1 }} value={searchValue} onChangeText={(text) => setSearchValue(text)}/>
                    </View>
                    <TouchableOpacity style={{ borderWidth:1, borderColor:Colors.brand.midnight, borderRadius:8, padding:8 }}>
                        <Text size={14} color={Colors.brand.midnight} textAlign='center'>Search</Text>
                    </TouchableOpacity>
                </View>
                <FlatList data={tags} renderItem={renderTags}/>
            </ScrollView>
        </View>
    )
}

const mapStateToProps = (state:any) => {
    return {
        player: state.player.player,
        tags: state.social.tags,
        player_tags: state.social.player_tags
    }
}

const mapDispatchToProps = (dispatch:any) => {
    return {
        social_getTags: (offset:number, tag_type:string) => dispatch(social_getTags(offset, tag_type)),
        social_savePlayerTag:(player_tag:PlayerTagProps) => dispatch(social_savePlayerTag(player_tag))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TagsScreen)